import { __ } from '@wordpress/i18n';

const tabs = new Map();

tabs.set(0, __('Trends by Service Type', 'hst'));
tabs.set(1, __('Trends by Source of Funds', 'hst'));
tabs.set(2, __('Distribution by Service Type', 'hst'));
tabs.set(3, __('Distribution by Source of Funds', 'hst'));

export default tabs;
